import { connect } from 'react-redux';
import { withRouter } from "react-router";
import Users from '../../components/ManageUsers/ListUsers';

const mapState = ({auth: { user }}) => {
    return {
        user: user,
    };
};

export default connect(
mapState,
{},
)(withRouter(Users));